import {gql} from 'apollo-boost'

export const GET_COOKS = gql`
    query($query: String) {
        cooks(query: $query, orderBy : createdAt_DESC) {
            id
            name
            videoUrl
            # ingredients {id name}
        }
    } 
    `

export const GET_SEARCH_COOKS = gql`
    query($query: String) {
        cooks(query: $query, orderBy : createdAt_DESC) {
            id
            name
            videoUrl
            countries{name}
            categories {name}
            ingredients {name}
            createdBy{ id name}
            createdAt
        }
    } 
    `

export const GET_COOKS_BY_INGREDIENTS = gql`
    query($ingredients: [String!]!) {
        cooksByIngredients(ingredients: $ingredients) {
            id
            name
            videoUrl
            countries{name}
            categories {name}
            ingredients {name}
            createdBy{ id name}
            createdAt
        }
    } 
    `

export const GET_COOKS_IDS = gql`
    query {
        cooks {
            id
            name
            videoUrl
        }
    } 
    `

export const GET_COOK = gql`
    query($id: ID!) {
        cook(id: $id) {
            id
            name
            videoUrl
            countries{name}
            categories {name}
            ingredients {name}
            createdBy{ id name}
            createdAt
        }
    } 
    `

export const INFINITE_SCROLL_COOKS = gql`
    query($pageNum: Int!, $pageSize: Int!) {
        infinteScrollCooks(pageNum: $pageNum, pageSize: $pageSize, orderBy : createdAt_DESC) {
            hasMore
            cooks {
                id
                name
                videoUrl
                createdBy{id name}
                categories{name}
                countries {name}
                ingredients {name}
                createdAt
            }
        }
    }
`

export const MY_COOKS = gql`
    query($pageNum: Int!, $pageSize: Int!) {
        myCooks(pageNum: $pageNum, pageSize: $pageSize, orderBy : createdAt_DESC) {
            hasMore
            cooks {
                id
                name
                videoUrl
                createdBy{id name}
                categories{name}
                countries {name}
                ingredients {name}
                createdAt
            }
        }
    }
`

export const FAVORITE_COOKS = gql`
    query($pageNum: Int!, $pageSize: Int!) {
        favorites(pageNum: $pageNum, pageSize: $pageSize, orderBy : createdAt_DESC) {
            hasMore
            cooks {
                id
                name
                countries{name}
                categories {name}
                videoUrl
                ingredients {name}
                createdBy{id name}
                createdAt
            }
        }
    }
`

export const ADD_COOK = gql`
    mutation(
        $name: String!
        $videoUrl: String!
        $ingredients: [String!]!
        $countries: [String!]!
        $categories: [String!]!
    ) {
        createCook(
            data: {
                name:  $name
                videoUrl: $videoUrl
                ingredients: $ingredients
                countries: $countries
                categories: $categories
            }
        ) {
            id
            name
            countries{name}
            categories {name}
            ingredients {name}
            createdBy {id name}
        }
    }
`

export const UPDATE_COOK = gql`
    mutation(
        $id: ID!
        $name: String
        $videoUrl: String
        $ingredients: [String!]
        $countries: [String!]
        $categories: [String!]
    ) {
        updateCook(
            id: $id
            data: {
                name:  $name
                videoUrl: $videoUrl
                ingredients: $ingredients
                countries: $countries
                categories: $categories
            }
        ) {
            id
            name
            createdBy{id name}
            categories{name}
            countries {name}
            videoUrl
            ingredients {name}
            createdAt
        }
    }
`

export const DELETE_COOK = gql`
    mutation($id: ID!) {
        deleteCook(id: $id) {
            id
        }
    }
`
